import { ExchangeIcon } from "lola-framework-ui-test";
import { useStore } from "../store/globalState";
import { useTranslation } from "react-i18next";
import type { KeyboardEvent } from "react";

export interface ExchangeFeeInfoProps {
  fee: string;
  currency: string;
  from?: string;
  /**
   * Page context. The chip is absolutely positioned relative to its
   * `.quote-container`, whose height differs per page (request has 1 quote
   * row, transfer has 2). The variant scopes the vertical offset so tuning
   * one page does not affect the other.
   */
  variant?: "request" | "transfer";
  onClick?: () => void;
}

export const ExchangeFeeInfo: React.FC<ExchangeFeeInfoProps> = ({
  fee,
  currency,
  from = "USD",
  variant,
  onClick,
}) => {
  const { t } = useTranslation();
  const { theme } = useStore();
  const colorConfig = theme.whiteView;
  const { bodyCopy, textColorBtn } = colorConfig;

  const handleKeyDown = (e: KeyboardEvent<HTMLElement>) => {
    if (!onClick) return;
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onClick();
    }
  };

  return (
    <section
      className={`exchange-chips-container${
        variant ? ` exchange-chips-container--${variant}` : ""
      }${onClick ? " exchange-chips-container--clickable" : ""}`}
      style={
        {
          "--bgc": bodyCopy,
          "--colorc": textColorBtn,
        } as React.CSSProperties
      }
      onClick={onClick}
      onKeyDown={handleKeyDown}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      <p className="exchange-icon">i</p>
      <p className="exchange-info">
        {t("exchange.rate", { from, rate: fee, to: currency })}
      </p>
      <section className="exchange-icon">
        <ExchangeIcon size={12} colors={[textColorBtn, textColorBtn]} />
      </section>
    </section>
  );
};
